import { render, staticRenderFns } from "./Dimension.vue?vue&type=template&id=c2f2c9be&"
import script from "./Dimension.vue?vue&type=script&lang=ts&"
export * from "./Dimension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports